import Log from '~/_Utility/Log';

import Async from '~/Async';

class Notice {

    /**
     * @since 2.0.0
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.selector = '[data-action="p3-remove-notice"]';

        // Get our async requestor
        this.async = new Async();

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.0.0
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('Notice initialized.', 'init');

        // Search for our elements
        $(this.selector).each((i, notice) => {

            // Declare and initialize
            let id = $(notice).data('notice-id');

            // Run the async post
            this.async.post('remove-notice', {
                params: {
                    id: id
                }
            });

        });

    }

}

export default Notice;